export const agentSetupConstants = {
	CHANGE_AGENT_STATUS_SUCCESS: "CHANGE_AGENT_STATUS_SUCCESS",
	CHANGE_AGENT_STATUS_ERROR: "CHANGE_AGENT_STATUS_ERROR",

	GET_AGENT_COMPANIES_SUCCESS: "GET_AGENT_COMPANIES_SUCCESS",
	GET_AGENT_COMPANIES_ERROR: "GET_AGENT_COMPANIES_ERROR",

	GET_AGENT_FORM_DATA_REQUEST: "GET_AGENT_FORM_DATA_REQUEST",
	GET_AGENT_FORM_DATA_SUCCESS: "GET_AGENT_FORM_DATA_SUCCESS",
	GET_AGENT_FORM_DATA_ERROR: "GET_AGENT_FORM_DATA_ERROR",

	GET_WHO_CAN_THEY_SEE_SUCCESS: "GET_WHO_CAN_THEY_SEE_SUCCESS",
	GET_WHO_CAN_THEY_SEE_ERROR: "GET_WHO_CAN_THEY_SEE_ERROR",

	GET_WHO_CAN_SEE_THEM_SUCCESS: "GET_WHO_CAN_SEE_THEM_SUCCESS",
	GET_WHO_CAN_SEE_THEM_ERROR: "GET_WHO_CAN_SEE_THEM_ERROR",
};
